import { FC, useState } from "react";
import {
  AdvancedMarker, 
//   useAdvancedMarkerRef, 
  MapCameraChangedEvent,
  Map
} from '@vis.gl/react-google-maps';
// import MapHandler from "components/GoogleMaps/MapHandler";
import { APIProvider } from '@vis.gl/react-google-maps';
import { GOOGLE_MAPS_API_KEY } from "data/constants";

interface LocationsMapProps {
    id?: string;
    className?: string;
    markers: { lat: number; lng: number }[];
    defaultCenter: { lat: number; lng: number };
}

const LocationsMap: FC<LocationsMapProps> = ({
    id = "locations-map",
    className = "",
    markers,
    defaultCenter
}) => {

    // const [markerRef, marker] = useAdvancedMarkerRef();
    const [currentCenter, setCurrentCenter] = useState<{ lat: number; lng: number }>({
        lat: defaultCenter.lat,
        lng: defaultCenter.lng,
    });
    
    const handleCameraChange = (event: MapCameraChangedEvent) => {
        const newCenter = event.map.getCenter();
        if (newCenter) {
            setCurrentCenter({ lat: newCenter.lat(), lng: newCenter.lng() });
        }
    }

    return (
        <div className={`w-full h-full rounded-xl overflow-hidden ${className}`}>
            <APIProvider
                apiKey={GOOGLE_MAPS_API_KEY} 
                libraries={['maps']}
                authReferrerPolicy="origin"
                onError={(e) => console.error("Error loading Google Maps API", e)}
                onLoad={() => console.log("Google Maps API loaded successfully")}
            >
                <Map
                    center={currentCenter}
                    defaultCenter={defaultCenter}
                    defaultZoom={10}
                    mapId={id}
                    onCameraChanged={handleCameraChange}
                >
                    { markers && markers.length > 0 && markers.map((marker, index) => (
                        <AdvancedMarker key={index} position={marker} />
                    ))}
                </Map>
                {/* <MapHandler place={place} marker={marker} /> */}
            </APIProvider>
        </div>
    );
};

export default LocationsMap;